/// <reference path="../../../../../typings/interact/interact.d.ts" />
import interact from 'interact.js'

import { Directive, ElementRef, Input, EventEmitter, Output, OnInit } from '@angular/core';
import { MiniBook } from '../../../services/ShelvableBackend/BookArray'
import { NgZone } from '@angular/core'

navigator.vibrate = navigator.vibrate || navigator['webkitVibrate'] || navigator['mozVibrate'] || navigator['msVibrate'];

declare module 'interact.js/interact' {
    interface Interaction {
        rightBook?: BookElement,
        leftBook?: BookElement,
        bookBeingHeld?: BookElement,
        originalBook?: BookElement,
        isBookCloned: boolean
    }
}

interface BookElement extends HTMLElement {
    insertBookBefore: (MiniBook) => void;
    isDropAllowed: () => boolean;
    removeBook: () => void;
    book: MiniBook
}

@Directive({ selector: '[allowDrag]' })
export class AllowDragDirective implements OnInit {
    @Input() allowDrag:boolean;
    @Input() cloneOnDrag:boolean;
    @Input() book:MiniBook;

    @Output() onInsertBefore:EventEmitter<{bookToInsertBefore:MiniBook}> = new EventEmitter<{bookToInsertBefore:MiniBook}>();
    @Output() onRemove:EventEmitter<{noConfirm: boolean}> = new EventEmitter<{noConfirm: boolean}>();

    ngOnInit() {
        this.el.nativeElement.book = this.book;   

        if (this.allowDrag) interact.interact(this.el.nativeElement).draggable({
            manualStart: true,
            autoScroll: true,
            onmove: (event) => {
    
                var bookBeingHeld = event.interaction.bookBeingHeld;
    
                var targetElement:BookElement;
                if (event.interaction.dropTarget) {
                    targetElement = <BookElement> event.interaction.dropTarget.element();
                } else {
                    var clientCoords: {x:number, y:number} = {
                        x: event.interaction.curCoords.client.x,
                        y: event.interaction.curCoords.client.y
                    }
    
                    function checkForBookAt(x,y) {
                        var foundElement = document.elementFromPoint(x,y);
                        if (foundElement) {
                            var foundBook = foundElement.closest('book, .empty');
                            if (foundBook &&  event.interaction.element !== foundBook && !foundBook.classList.contains('cloned-book')) {
                                targetElement = <BookElement> foundBook;
                            }
    
                        }
                    }
    
                    while (!targetElement && clientCoords.x <= document.documentElement.clientWidth) {
                        clientCoords.x++;
                        checkForBookAt(clientCoords.x,clientCoords.y);
                    }
    
                    while (!targetElement && clientCoords.x >= 0) {
                        clientCoords.x--;
                        checkForBookAt(clientCoords.x,clientCoords.y);
                    }
                }
    
                if (targetElement && (targetElement.classList.contains('books') || targetElement.classList.contains('end') || targetElement.isDropAllowed())) {
                    AllowDragDirective.removeAllClasses('dragging-over');
                    var dragParent = event.interaction.target.element().closest('.end, .books');
                    var dropParent = targetElement.closest('.end, .books');
                    dropParent.classList.add('dragging-over');
    
                    if (targetElement.tagName.toLowerCase() === 'book') {
                        AllowDragDirective.removeAllClasses('dragging-over-ghost');
                        var targetBounds = targetElement.getBoundingClientRect();
                        var curCoords = event.interaction.curCoords.page;
    
                        if (curCoords.x < targetBounds.left + ((targetBounds.right - targetBounds.left) / 2)) {
                            event.interaction.rightBook = targetElement;
                            event.interaction.leftBook = <BookElement> targetElement.previousElementSibling;
                            if (event.interaction.leftBook === event.target) {
                                event.interaction.leftBook = null;
                                event.interaction.rightBook = null;
                            }
                        } else {
                            event.interaction.leftBook = targetElement;
    
                            if (targetElement.nextElementSibling.tagName.toLowerCase() === 'book') {
                                event.interaction.rightBook = <BookElement>targetElement.nextElementSibling;
                            } else {
                                // hovering to the right of the last book - make rightBook the .end-ghost-book
                                event.interaction.rightBook = <BookElement> dropParent.querySelector('.end-ghost-book')
                            }
                            
                            if (event.interaction.rightBook === event.target) {
                                event.interaction.leftBook = null;
                                event.interaction.rightBook = null;
                            }
                        }
                        
                        if (event.interaction.leftBook) event.interaction.leftBook.classList.add('drop-target-left');
                        if (event.interaction.rightBook) event.interaction.rightBook.classList.add('drop-target-right');
    
                        AllowDragDirective.removeAllClasses('drop-target-right', event.interaction.rightBook);
                        AllowDragDirective.removeAllClasses('drop-target-left', event.interaction.leftBook);
                    } else {
                        // must be dragging over .end-ghost-book
                        AllowDragDirective.removeAllClasses('drop-target-right');
                        AllowDragDirective.removeAllClasses('drop-target-left');
    
                        if (targetElement.classList.contains('books') || targetElement.classList.contains('end')) {
                            targetElement = <BookElement> targetElement.querySelector('.end-ghost-book');
                        }

                        targetElement.classList.add('dragging-over-ghost');
    
                        var isLastBook = (event.interaction.target.element().nextElementSibling.tagName.toLowerCase() !== 'book') && (dragParent === dropParent);
                        if (!isLastBook) {
                            event.interaction.rightBook = targetElement;
                        }
                    }
    
                } else {
                    event.interaction.leftBook = null;
                    event.interaction.rightBook = null;
                    AllowDragDirective.removeAllClasses('drop-target-right');
                    AllowDragDirective.removeAllClasses('drop-target-left');
                    AllowDragDirective.removeAllClasses('dragging-over-ghost');
                }
    
                // keep the dragged position in the data-x/data-y attributes
                var currentLocation = {
                    x: (parseFloat(bookBeingHeld.getAttribute('data-x')) || 0) + event.dx,
                    y: (parseFloat(bookBeingHeld.getAttribute('data-y')) || 0) + event.dy,
                }
    
                // translate the element
                if (this.cloneOnDrag) {
                    // cloned nodes are fixed, so we can change left and top.
                    // this means that if the user scrolls in the middle of dragging, it stays under the cursor.
                    // (it goes out of whack if we use transform)
                    bookBeingHeld.style.left = event.clientX + 'px';
                    bookBeingHeld.style.top = event.clientY + 'px';
                } else {
                    bookBeingHeld.style.webkitTransform = bookBeingHeld.style.transform = 'translate(' + currentLocation.x + 'px, ' + currentLocation.y + 'px)';
                }
    
                // update the position attributes
                bookBeingHeld.setAttribute('data-x', currentLocation.x.toString());
                bookBeingHeld.setAttribute('data-y', currentLocation.y.toString());
            },
            onend: (event) => {
                var bookBeingHeld = event.interaction.bookBeingHeld;
                var originalBook = event.interaction.originalBook;
    
                if (originalBook) originalBook.classList.remove('cloned-book-orig');
    
                // if bookBeingHeld is a clone, remove it
                if (event.interaction.isBookCloned) document.body.removeChild(event.interaction.bookBeingHeld);
    
                // clean up old popovers
                var oldPopovers = document.getElementsByTagName('ngb-popover-window');
                if (oldPopovers.length > 0) console.log('Removing ' + oldPopovers.length + ' old popover(s)');
                for (var popover of oldPopovers) {
                    if (popover.classList.contains('book_popover')) {
                        popover.parentNode.removeChild(popover);
                    }
                }
                
                event.interaction.target.element().classList.remove('dragging-book');
                AllowDragDirective.removeAllClasses('dragging-over');
    
                if (event.interaction.dropTarget) {
                    event.interaction.dropTarget.element().classList.remove('dragging-over-ghost')
                }
    
                var validDrop = false;
                if (event.interaction.rightBook) {
                    validDrop = true;
                    event.target.classList.add('book-hide');
    
                    event.interaction.rightBook.insertBookBefore((<BookElement> event.target).book);
    
                    var dragParent = event.interaction.target.element().closest('.end, .books');
                    var dropParent = event.interaction.rightBook.closest('.end, .books');
    
                    if (dragParent !== dropParent) {
                        (<BookElement> event.interaction.target.element()).removeBook();
                    }
    
                    setTimeout(() => {
                        event.target.classList.remove('book-hide');
                        event.target.classList.add('book-show');      
                    });
                    
                    setTimeout(() => {
                        event.target.classList.remove('book-show');
                    }, 2000);
                }
                
                var overflowHiddenParent = <HTMLElement> event.interaction.target.element().closest('.shelf_books_and_end');
                if (overflowHiddenParent) overflowHiddenParent.style.overflow = 'hidden';
    
                var container = event.interaction.target.element().closest('.end, .books');
                if (container) container.classList.remove('dragging-over');
    
                setTimeout(() => {
                    document.body.classList.toggle('dragging');
                }, 500);
    
                // keep the dragged position in the data-x/data-y attributes
                bookBeingHeld.setAttribute('data-x', '0');
                bookBeingHeld.setAttribute('data-y', '0');
    
                if (!validDrop) {
                    bookBeingHeld.classList.add('transition-transform');
                }
                setTimeout(() => {
                    bookBeingHeld.style.webkitTransform = bookBeingHeld.style.transform = 'translate(0px, 0px)';
                    bookBeingHeld.style.left = '';
                    bookBeingHeld.style.top = '';
                });
                setTimeout(() => {
                    bookBeingHeld.classList.remove('transition-transform');
                }, 200);
    
                AllowDragDirective.removeAllClasses('drop-target-right');
                AllowDragDirective.removeAllClasses('drop-target-left');
            },
            onstart:(event) => {
                var overflowHiddenParent = <HTMLElement> event.interaction.target.element().closest('.shelf_books_and_end');
                if (overflowHiddenParent) overflowHiddenParent.style.overflow = 'initial';
                document.body.classList.add('dragging');
                event.interaction.target.element().classList.add('dragging-book');
    
                if (this.cloneOnDrag) {
                    var oldNode = event.interaction.target.element();
                    var newNode = <HTMLElement> event.interaction.target.element().cloneNode(true);
                    document.body.appendChild(newNode);
    
                    newNode.style.position = 'fixed';
                    var oldNodePosition = oldNode.getBoundingClientRect();
                    var nodeWidth = oldNodePosition.right - oldNodePosition.left;
                    var nodeHeight = oldNodePosition.top - oldNodePosition.bottom;
                    
                    // put the middle of the new node roughly on the cursor
                    newNode.style.left = event.clientX + 'px';
                    newNode.style.top = event.clientY + 'px';
                    // 1.5 here was trial and error
                    newNode.style.webkitTransform = newNode.style.transform = 'translate(-' + (nodeWidth / 1.5) + 'px' + ',' + (nodeHeight / 2) +  'px' + ')';

                    newNode.classList.add('cloned-book');
                    oldNode.classList.add('cloned-book-orig');
    
                    event.interaction.bookBeingHeld = <BookElement> newNode;
                    event.interaction.originalBook = <BookElement> oldNode;
                    event.interaction.isBookCloned = true;
                } else {
                    event.interaction.bookBeingHeld = <BookElement> event.interaction.target.element();
                    event.interaction.isBookCloned = false;
                }
            }
        }).on('move', (event) => {
            var interaction = event.interaction;
            if (!interaction.mouse) {
                return;
            }
    
            if (!interaction.interacting()) {
                interaction.start({ name: 'drag' }, event.interactable, event.currentTarget);
            }
        }).on('hold', (event) => {
            var interaction = event.interaction;
            if (interaction.mouse) {
                return;
            }
     
            if (navigator.vibrate) {
                navigator.vibrate(100);        
            }
     
            if (!interaction.interacting()) {
                interaction.start({ name: 'drag' }, event.interactable, event.currentTarget);
            }
        });
    }

    constructor(private el: ElementRef, private zone:NgZone) {
        
        el.nativeElement.insertBookBefore = (book) => {
            zone.run(() => {
                this.onInsertBefore.emit({bookToInsertBefore: book });
            });
        }

        el.nativeElement.removeBook = () => {
            zone.run(() => {
                this.onRemove.emit({noConfirm: true });
            });
        }

    }

    
    static removeAllClasses(className, exceptForElement?) {
        var targets = document.getElementsByClassName(className)
        for(var i = 0; i < targets.length; i++) {
            if (targets[i] !== exceptForElement) {
                targets[i].classList.remove(className);
            }
        }
    }
}




// WEBPACK FOOTER //
// ./web/static/components/book/directives/AllowDrag.ts